import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, Modal, Tooltip, InputGroup, Form } from 'react-bootstrap';
import { EditionService } from '../../../services/EditionService';
import { UserService } from '../../../services/UserService';
import ErrorManager from "../../../components/error-manager/ErrorManager";

//import './SendMailDialog.scss';

const ChangeEmailDialog = ({ show, setCloseModal }) => {

    const [showModal, setShowModal] = useState(false);
    const [globalError, setGlobalError] = useState();
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [newEmail, setNewEmail] = useState();
    const [newEmailConfirm, setNewEmailConfirm] = useState();
    const [isSaved, setIsSaved] = useState(false);

    let inputRef = useRef();

    useEffect(() => {
        setShowModal(show)
        if (show) {
            resetValues()
        }
    }, [show]);

    function resetValues() {
        setGlobalError()
        setIsSendLoading(false)
        setIsSaved(false)
        setNewEmail()
        setNewEmailConfirm()
    }

    function handleClose(e) {
        setCloseModal()
    }

    function saveNewEmail() {
        setIsSendLoading(true)
        UserService.updateEmail({ mail: newEmail }).then(res => {
            setIsSendLoading(false)
            setIsSaved(true)
        }).catch(error => {
            setGlobalError(error)
            setIsSendLoading(false)
        });

    }

    return (
        <div id="ChangeEmailDialog">
            <Modal show={showModal} onHide={() => handleClose()} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Changer l'adresse email de l'utilisateur</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <ErrorManager error={globalError} />

                    {isSaved &&
                        <Alert variant="success">Un email a été envoyé à votre nouvelle adresse pour confirmation.</Alert>
                    }

                    {!isSaved &&
                        <Form>
                            <Form.Group className="mb-2">
                                <Form.Control disabled={isSendLoading} onChange={e => setNewEmail(e.target.value)} type="text" placeholder="Nouvelle adresse email" />
                            </Form.Group>
                            <Form.Group hasvalidation="true" className="mb-2">
                                <Form.Control disabled={isSendLoading} isInvalid={newEmailConfirm && (newEmail != newEmailConfirm)} onChange={e => setNewEmailConfirm(e.target.value)} type="text" placeholder="Confirmer l'adresse email" />
                                <Form.Control.Feedback type="invalid">
                                    Les adresses email doivent être identiques
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Form>
                    }

                </Modal.Body>
                <Modal.Footer>

                    <Button disabled={isSendLoading} variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>

                    {!isSaved &&
                        <Button disabled={isSendLoading || !newEmail || !newEmailConfirm || (newEmail != newEmailConfirm)} className="ms-1" onClick={() => saveNewEmail()}>
                            Enregistrer
                        </Button>
                    }

                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ChangeEmailDialog;
